module.exports = __webpack_public_path__ + "img/zhan5.bbeab1d8.png";